import { Form, FormInstance } from "antd";
import { DatePicker } from "antd";
import { DATE_FORMAT } from "../../../../../lib/constants";
import { useCallback, useMemo } from "react";
import { FormButtons } from "./FormButtons";
import { useExport } from "../hooks/useExport";
import dayjs from "../../../../../configs/dayjs";

const { RangePicker } = DatePicker;

type FormItemsProps = {
  form: FormInstance;
  closeModal: (value: boolean) => void;
};

export const FormItems = ({ form, closeModal }: FormItemsProps) => {
  const initialValues = useMemo(() => {
    const now = dayjs();

    return {
      dates: [now, now],
    };
  }, []);

  const close = useCallback(() => closeModal(false), [closeModal]);

  const { onExportClicked, isLoading } = useExport(form, close);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="pt-6 processing-print-form"
        initialValues={initialValues}
      >
        <Form.Item
          className="mb-4 w-100"
          label="Payoffs Date Range"
          name="dates"
        >
          <RangePicker
            className="w-100"
            format={DATE_FORMAT}
            disabled={isLoading}
          />
        </Form.Item>
      </Form>

      <FormButtons
        isDisabled={isLoading}
        onPrint={onExportClicked}
        closeModal={close}
      />
    </>
  );
};
